/** Human-facing sales order reference. API routes still use the raw `id` (cuid). */
export function formatOrderReference(orderId: string): string {
  const id = String(orderId || '').trim();
  return id ? `# ORD-${id}` : '';
}

export function normalizeOrderIdSearchQuery(raw: string): string {
  let s = String(raw || '').trim();
  if (!s) return '';
  s = s.replace(/^#\s*/i, '');
  s = s.replace(/^\s*ord\s*-\s*/i, '');
  return s.trim();
}

export function orderIdMatchesSearch(orderId: string, query: string): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  if (orderId.toLowerCase().includes(needle)) return true;
  if (formatOrderReference(orderId).toLowerCase().includes(needle)) return true;
  const normalized = normalizeOrderIdSearchQuery(query).toLowerCase();
  if (normalized && normalized !== needle && orderId.toLowerCase().includes(normalized)) {
    return true;
  }
  return false;
}
